import React from 'react';
import { EditItineraryModal } from './EditItineraryModal/EditItineraryModal';
import { EditItinerary } from './EditItinerary/EditItinerary';
import { ItineraryDetails } from './ItineraryDetails/ItineraryDetails';
import { ItineraryList } from './ItineraryList';
import { useMapDisplayContext } from '../MapDisplayContext';
import { useItineraries } from '../useItineraries';

export const Itineraries: React.FC = () => {
  const {
    setNewItinerary,
    setSelectedItineraryDate,
    activePage,
    setActivePage,
    replaceUrlParams,
  } = useMapDisplayContext();

  const { selectedItinerary } = useItineraries();

  if (activePage === 'ITINERARIES.LIST') {
    return (
      <ItineraryList
        onItineraryClick={async (itinerary) => {
          await replaceUrlParams({ itin: itinerary.id, pg: 'ITINERARIES.DETAILS' });
          setSelectedItineraryDate(itinerary.date_itineraries[0].date);
        }}
        onCreateItineraryClick={() => {
          setActivePage('ITINERARIES.CREATE');
        }}
      />
    );
  }

  if (activePage === 'ITINERARIES.DETAILS' && selectedItinerary) {
    return (
      <ItineraryDetails
        itinerary={selectedItinerary}
        onBackClick={async () => {
          await replaceUrlParams({ itin: '', pg: 'ITINERARIES.LIST' });
          setSelectedItineraryDate(null);
        }}
      />
    );
  }

  if (activePage === 'ITINERARIES.CREATE') {
    return (
      <EditItineraryModal
        onBack={() => setActivePage('ITINERARIES.LIST')}
        onCreateClick={(itinerary) => {
          setNewItinerary(itinerary);
          setActivePage('ITINERARIES.EDIT');
        }}
        mode="CREATE"
      />
    );
  }

  if (activePage === 'ITINERARIES.EDIT') {
    return (
      <EditItinerary
        onBackClick={() => setActivePage('ITINERARIES.LIST')}
        onEditDetailsClick={() => setActivePage('ITINERARIES.EDIT_DETAILS')}
        onSaveClick={() => {
          setActivePage('ITINERARIES.LIST');
        }}
      />
    );
  }

  if (activePage === 'ITINERARIES.EDIT_DETAILS') {
    return (
      <EditItineraryModal
        onBack={() => setActivePage('ITINERARIES.EDIT')}
        onCreateClick={(itinerary) => {
          setNewItinerary(itinerary);
          setActivePage('ITINERARIES.EDIT');
        }}
        mode="EDIT"
      />
    );
  }

  return null;
};
